var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-you-tube"},[_c('div',{staticClass:"video-you-tube__wrapper"},[_c('iframe',{attrs:{"allow":_vm.params.allow,"height":_vm.params.height,"src":`https://www.youtube.com/embed/${_vm.params.src}`,"width":_vm.params.width,"allowfullscreen":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }